import { INTERNAL_LIGHT_MODE_MAPPING } from './variables/light';
/**
 * Maps the CSS variable to the fallback specified within the light theme.
 * @param cssVariable The CSS variable to map
 * @returns {CssVariableWithFallback} mapped string using `var()`, in the format of `var(cssVariable, fallback)`
 */
export function mapCssVariableToFallback(cssVariable) {
    return `var(${cssVariable}, ${INTERNAL_LIGHT_MODE_MAPPING[cssVariable]})`;
}
